var _rect, _defs, _title, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWaves = function SvgWaves(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1648.39,
    height: 1087.5,
    style: {},
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{opacity:0.5;}.cls-1{fill:url(#linear-gradient);}.cls-2{opacity:0.3;fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6687.259765625,
    y1: 815.6199951171875,
    x2: 9498.6201171875,
    y2: 815.6199951171875,
    gradientTransform: "translate(-6687.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75c278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5fc3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 7349.330078125,
    y1: 543.75,
    x2: 9294.6201171875,
    y2: 543.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 7219.60986328125,
    y1: 631.75,
    x2: 8783.1298828125,
    y2: 631.75,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    className: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1376.315342694521,951.0607788576672 c91.26641376112912,0 96.22239933232413,-206.9843216267236 219.8757602828773,-180.05776566267014 a121.30146062910717,121.30146062910717 0 0 1 52.19915682077408,25.507206941011418 V1087.499993532896 H681.5973510742188 c211.5766665367264,0 387.72830879946923,-229.96954728116725 499.739476778308,-229.96954728116725 S1285.0489378827842,951.0607788576672 1376.315342694521,951.0607788576672 z",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1352.0397936445443,627.5667697719728 c83.7063339907927,0 77.50694668839242,187.06066521187677 145.7118949212636,187.06066521187677 c64.67416682469275,0 71.35448999971231,-372.13893261551857 150.6385533335797,-364.8486501777188 V1087.499993532896 H1069.9062964522855 C1228.0228009821913,1087.499993532896 1268.3276067511251,627.5667697719728 1352.0397936445443,627.5667697719728 z",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1163.2724077077728,799.7477456168344 c64.78560465879718,0 64.78560465879718,186.99614009270772 132.06972753465016,186.99614009270772 s57.99384812436938,-380.2385981015359 139.54183477774222,-429.7926009108596 C1509.159264266491,511.84300005435944 1512.1328251812738,858.7914335389905 1566.9537244029925,858.7914335389905 c42.59802939914107,0 49.0906659168495,-94.66815835505804 81.43655329396461,-136.8790952102354 V1087.499993532896 h-654.5422360897064 C1095.9882624584388,1087.4882519300736 1098.4809188234758,799.7477456168344 1163.2724077077728,799.7477456168344 z",
    id: "svg_3"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWaves);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/waves.e0bbe4bcc3f2c59a9be4479d3d83089b.svg";